import React from 'react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_TOTAL, OFFER_ANCHOR, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="bg-noche" data-id="element-58" data-mp="c70xva6rjfok">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-59" data-mp="c4fuuhuqatp8">
        <h2 id="cierre" className="font-display text-[1.75rem] uppercase leading-none tracking-wide text-oro sm:text-5xl" data-id="element-60" data-mp="83m83rt0vkxx">
          Una última oportunidad
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-white/90" data-id="element-61" data-mp="h5c65gheti4o">
          Puedes seguir guardando videos sobre fórmulas, reacciones, tabla
          periódica y ejercicios de química sin saber qué estudiar primero. O
          puedes comenzar hoy a construir conocimientos siguiendo una ruta
          organizada desde cero.
        </p>
        <p className="mx-auto mt-1.5 max-w-xl font-sub text-sm font-extrabold leading-snug text-white" data-id="element-62" data-mp="zwvaprr3148t">
          No necesitas ser experto en química para empezar.{' '}
          <span className="text-oro" data-id="element-63" data-mp="2c7107tri8hsr">Necesitas dar el primer paso.</span>
        </p>

        <Reveal className="mt-3 rounded-2xl border-4 border-dashed border-oro bg-white p-3 text-noche" data-id="element-64" data-mp="2h3zqg181s4lo">
          <p className="font-sub text-sm font-extrabold uppercase leading-tight text-noche" data-id="element-65" data-mp="2m4xbqmoctere">
            {PRODUCT_NAME}
          </p>
          <p className="mt-1 inline-block rounded-md bg-oro px-2 py-0.5 font-display text-3xl uppercase leading-tight tracking-wide text-noche" data-id="element-66" data-mp="2v3sj4234wuwa">
            6 Tomos + 5 Bonos
          </p>
          <p className="mt-1 text-xs font-semibold text-noche/80 sm:text-sm" data-id="element-67" data-mp="34tc3jc6hwwt9">
            Valor de los bonos:{' '}
            <span className="line-through decoration-red-600 decoration-2" data-id="element-68" data-mp="39sych9fajqw9">{BONUS_TOTAL}</span>
          </p>
          <p className="mx-auto mt-1.5 w-fit rounded-xl border-2 border-noche bg-oro px-3 py-1 font-display text-5xl leading-none tracking-wide text-noche sm:text-6xl" data-id="element-69" data-mp="3esb03wdzl1zw">
            <span className="text-2xl sm:text-3xl" data-id="element-70" data-mp="1jod0ckl9dbzp">Hoy:</span> {PRICE}
          </p>

          <CtaButton href={OFFER_ANCHOR} size="lg" className="mt-3" data-id="element-71" data-mp="1jlz5abqkvzs5">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2.5 text-xs font-semibold text-noche/80" data-id="element-72" data-mp="1sh6tnlxjibwk">
            Acceso Inmediato • Entrega Digital • Garantía de 7 Días
          </p>
        </Reveal>
      </div>
    </section>;
}